export default __webpack_public_path__ + "static/media/balaji-malliswamy-SPJQ4mtxxKo-unsplash.345fe6ea.jpg";